import { StateDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as StateActions from './state.actions';

export const STATE_FEATURE_KEY = 'epimsState';

export interface StateState extends EntityState<StateDto> {
  selectedStateId?: string | number; // which State record has been selected
  loaded: boolean; // has the State list been loaded
  error?: string | null; // last none error (if any)
}

export interface StatePartialState {
  readonly [STATE_FEATURE_KEY]: StateState;
}

export const stateAdapter: EntityAdapter<StateDto> = createEntityAdapter<
  StateDto
>({
  selectId: (state) => state.id,
  sortComparer: false,
});

export const initialState: StateState = stateAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedStateId: null,
});

const stateReducer = createReducer(
  initialState,
  on(StateActions.loadState, (staten) => ({
    ...staten,
    loaded: true,
    error: null,
  })),
  on(StateActions.loadStateSuccess, (staten, { state }) =>
    stateAdapter.addAll(state, { ...staten, loaded: false })
  ),
  on(StateActions.loadStateFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(StateActions.addState, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(StateActions.addStateSuccess, (state, { newState }) =>
    stateAdapter.addMany(newState, { ...state, loaded: false })
  ),
  on(StateActions.addStateFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(StateActions.updateState, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(StateActions.updateStateSuccess, (state, { updateState }) =>
    stateAdapter.upsertMany(updateState, { ...state, loaded: false })
  ),
  on(StateActions.updateStateFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(StateActions.removeState, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(StateActions.removeStateSuccess, (state, { ids }) =>
    stateAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(StateActions.removeStateFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: StateState | undefined, action: Action) {
  return stateReducer(state, action);
}
